'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UpdateA3(username, pin, serial, thumbprint, location) {
  this.a06 = null;
  this.a03 = null;
  this.a04 = null;
  this.a05 = null;
  this.a02 = null;
  this.a06 = username;
  this.a03 = pin;
  this.a04 = serial;
  this.a05 = thumbprint;
  this.a02 = location;
}
export { $c_Lpresto_types$proto$UpdateA3 as $c_Lpresto_types$proto$UpdateA3 };
$p = $c_Lpresto_types$proto$UpdateA3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UpdateA3;
/** @constructor */
function $h_Lpresto_types$proto$UpdateA3() {
}
export { $h_Lpresto_types$proto$UpdateA3 as $h_Lpresto_types$proto$UpdateA3 };
$h_Lpresto_types$proto$UpdateA3.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$UpdateA3)) {
    if ((this.a06 === x$0.a06)) {
      var x = this.a03;
      var x$2 = x$0.a03;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.a04;
      var x$4 = x$0.a04;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.a05;
      var x$6 = x$0.a05;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.a02;
      var x$8 = x$0.a02;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "UpdateA3";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.a06;
      break;
    }
    case 1: {
      return this.a03;
      break;
    }
    case 2: {
      return this.a04;
      break;
    }
    case 3: {
      return this.a05;
      break;
    }
    case 4: {
      return this.a02;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$UpdateA3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ma)));
}
export { $isArrayOf_Lpresto_types$proto$UpdateA3 as $isArrayOf_Lpresto_types$proto$UpdateA3 };
var $d_Lpresto_types$proto$UpdateA3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UpdateA3, "presto.types$proto$UpdateA3", ({
  ma: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UpdateA3 as $d_Lpresto_types$proto$UpdateA3 };
//# sourceMappingURL=presto.types$proto$-Update-A3.js.map
